import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { requireAppRequestAuth } from "@/lib/agent-mcp";
import { listMediaModels } from "@/lib/media-models";
import { checkRateLimit } from "@/lib/rate-limit";

function json(payload: unknown, status = 200) {
	return new Response(JSON.stringify(payload), {
		headers: { "Content-Type": "application/json" },
		status,
	});
}

export const Route = createFileRoute("/api/mcp/models")({
	validateSearch: z.object({
		type: z.enum(["audio", "image", "video"]).optional(),
	}),
	server: {
		handlers: {
			GET: async ({ request }) => {
				const rateLimitError = await checkRateLimit(request, "api");
				if (rateLimitError) return rateLimitError;

				const auth = await requireAppRequestAuth(request, { allowApiKey: true });
				if (auth instanceof Response) return auth;

				const { searchParams } = new URL(request.url);
				const type = searchParams.get("type");
				const models = listMediaModels(
					type === "audio" || type === "image" || type === "video"
						? type
						: undefined,
				);

				return json({ models });
			},
		},
	},
});
